module.exports = __webpack_public_path__ + "img/chart-pie-shortcut.6444e647.svg";